/** Turn Zoom SDK / Medplum / unknown throwables into a readable string (avoids "[object Object]"). */
export function formatUnknownError(err: unknown): string {
  if (err == null) return 'Unknown error';
  if (typeof err === 'string') return err;
  if (err instanceof Error) return err.message || err.name || 'Error';
  if (typeof err === 'object') {
    const record = err as Record<string, unknown>;
    for (const key of ['reason', 'errorMessage', 'message', 'statusText'] as const) {
      const value = record[key];
      if (typeof value === 'string' && value.trim()) return value.trim();
    }
    const code = record.errorCode ?? record.code;
    if (code != null && record.reason == null) {
      try {
        return `Error ${String(code)}: ${JSON.stringify(err)}`;
      } catch {
        return `Error ${String(code)}`;
      }
    }
    try {
      return JSON.stringify(err);
    } catch {
      return 'Unknown error';
    }
  }
  return String(err);
}
